export enum PopupAction {
  DENY,
  CONFIRM,
}

export class PopupHideData<T> {
  action: PopupAction;
  data?: T;
}
